import type {DriverProgressAssignmentQuery} from 'services/graphql/types';
import DeliveryAddressCard from '../DeliveryAddressCard';
import OrderItemsCard from '../OrderItemsCard';
import {DriverProgressContainer} from '../DriverProgress.styles';

interface Props {
  readonly assignment: NonNullable<
    NonNullable<DriverProgressAssignmentQuery['me']>['driverAccount']
  >['assignment'];
}

/**
 * Stage 1: click this button to begin the delivery.
 * @see https://www.figma.com/file/OtmeRPNdEEUwySX1znDSMv/Delivery-Driver-Web-%2F-Mobile?node-id=189%3A1973
 */
const StartDelivery = ({assignment}: Props) => {
  return (
    <DriverProgressContainer>
      <DeliveryAddressCard type="pickup" address={assignment.pickupAddress} />
      <DeliveryAddressCard
        type="dropoff"
        eventAt={assignment.eventAt}
        deliverySetup={assignment.deliverySetup}
        distanceInMiles={assignment.distanceInMiles ?? null}
        dropoffWindow={assignment.dropoffWindow}
        durationInMinutes={assignment.durationInMinutes ?? null}
        address={assignment.dropoffAddress}
        driverAskFor={assignment.driverAskFor}
      />
      {!!assignment.orderItems.length && <OrderItemsCard items={assignment.orderItems} />}
    </DriverProgressContainer>
  );
};

export default StartDelivery;
